// extracted by mini-css-extract-plugin
module.exports = {"root":"XsollaCopy_root_1jkpZ","icon":"XsollaCopy_icon_1_sl9","text":"XsollaCopy_text_2OB_b"};